import { Flex, Icon, InlineStack, Text, Tooltip } from '@customerio/pluma-components/react';
import type { IconName } from '@customerio/pluma-icons';

/**
 * Where one row is used, as much of it as a narrow column can hold: an icon
 * and a count per surface, with the whole reading spelled out in the tooltip.
 */

export type UsageChipProps = {
  icon: IconName;
  count: number;
};

export type UsageChipsProps = {
  /** The surfaces to show, in reading order. */
  chips: readonly UsageChipProps[];
  /** Every surface, named and counted, for the tooltip. */
  tooltip: string;
};

export function UsageChips({ chips, tooltip }: UsageChipsProps) {
  return (
    <Tooltip content={tooltip} placement="top">
      <InlineStack gap="100">
        {chips.map((chip) => (
          <Flex key={chip.icon} gap="050" alignItems="center">
            <Icon name={chip.icon} size="sm" />
            <Text size="sm">{chip.count}</Text>
          </Flex>
        ))}
      </InlineStack>
    </Tooltip>
  );
}
